import { render, staticRenderFns } from "./ShareSelectionsErrorModal.vue?vue&type=template&id=0f173e0f&"
import script from "./ShareSelectionsErrorModal.vue?vue&type=script&lang=js&"
export * from "./ShareSelectionsErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareSelectionsErrorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports